import(/* webpackMode: "eager", webpackExports: ["BehaviorAssessmentClient"] */ "/workspace/src/components/assessment/behavior-assessment-client.tsx");
